export default async (graphql, mutation, params) => {
  const result = await graphql.mutate(`{
      ${mutation}(${params}) {
        rejected {
          id
        },
        order {
          id
          orderItems {
            id
            target {
              name
              width
              dpi
              hasLimit
            }
            source {
              id
              name
              thumbnail
              restriction
              metaData {
                ratio {
                  width
                  height
                }
              }
            }
          }
        }
      }
    }`)

  const { order, rejected } = result[`${mutation}`]
  return {
    rejected,
    order,
    rejectedCount: rejected.length
  }
}



// WEBPACK FOOTER //
// ./src/modules/Basket/helpers/addToBasketMutation.js